import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import React, { useState } from 'react';
import PassportTable from '../home/PassportTable';
import PassportFilters from './PassportFilters';

const Passports = ({ classes, institute }) => {
  const [filters, setFilters] = useState(null);
  const [isFilterOptionFetched, setIsFilterOptionFetched] = React.useState(false);

  const handleFetchOptionFilters = () => {
    setIsFilterOptionFetched(true);
  };

  const handleApplyFilters = (filters) => {
    setFilters(filters);
  };

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Paper>
          <PassportFilters
            onOptionsFetched={handleFetchOptionFilters}
            handleApplyFilters={handleApplyFilters}
          />
        </Paper>
      </Grid>
      <Grid size={12}>
        <PassportTable filters={filters} institute={institute} title='Passports' showExportButton={true} />
      </Grid>
    </Grid>
  );
};

export default Passports;
